import { Component, ViewChild, ViewContainerRef, Input, ComponentFactoryResolver, OnDestroy, ComponentRef, AfterViewInit, AfterViewChecked, TemplateRef, EmbeddedViewRef } from "@angular/core";
import { NestedList, ChildInfo } from "./nested-list.component";

@Component({
    selector: "crew-nested-list-item",
    template: require('./nested-list-item.component.html')
})
export class NestedListItem implements AfterViewInit, AfterViewChecked, OnDestroy {

    private innerListComponentRef: ComponentRef<NestedList>;
    private itemViewRef: EmbeddedViewRef<any>;

    constructor(private resolver: ComponentFactoryResolver) { }

    @Input()
    item: any;

    @Input()
    getChildrenFuncs: ((item: any) => ChildInfo)[];

    @Input()
    displayName: string;

    @Input()
    detailsState: string;

    @Input()
    itemTemplate: TemplateRef<any>;

    @Input()
    searchText: string;

    @Input()
    showInactive: boolean;

    @Input()
    nestingLevel: number;

    ngAfterViewInit(): void {
        if (this.hasChildLevels && this.hasItem) {
            this.createInnerList();
        }

        if (!this.hasChildLevels && this.hasItem && this.hasItemTemplateToUse) {
            this.createItem();
        }
    }

    ngAfterViewChecked(): void {
        if (this.innerListComponentRef && ((this.searchText !== this.innerListComponentRef.instance.searchText) || (this.showInactive !== this.innerListComponentRef.instance.showInactive))) {
            this.innerListComponentRef.instance.searchText = this.searchText;
            this.innerListComponentRef.instance.showInactive = this.showInactive;
        }
    }

    ngOnDestroy(): void {
        if (this.innerListComponentRef) {
            this.innerListComponentRef.destroy();
        }

        if (this.itemViewRef) {
            this.itemViewRef.destroy();
        }
    }

    get hasItem(): boolean {
        return !!this.item;
    }

    get hasChildLevels(): boolean {
        return !!this.remainingLevels;
    }

    private get remainingLevels(): number {
        return this.getChildrenFuncs ? this.getChildrenFuncs.length : 0;
    }

    private get myItemContext(): Object {
        return { $implicit: this.item[this.displayName] };
    }

    private get itemTemplateToUse(): TemplateRef<any> {
        return this.hasInputItemTemplate ? this.itemTemplate : (this.hasDefaultItemTemplate ? this.defaultTemplateForItem : null);
    }

    private get hasItemTemplateToUse(): boolean {
        return !!this.itemTemplateToUse;
    }

    private get hasInputItemTemplate(): boolean {
        return !!this.itemTemplate;
    }

    private get hasDefaultItemTemplate(): boolean {
        return !!this.defaultTemplateForItem;
    }

    private createItem(): void {
        this.containerForItem.clear();
        this.itemViewRef = this.containerForItem.createEmbeddedView(this.itemTemplateToUse, this.myItemContext);
    }

    private createInnerList(): void {
        this.containerForInnerList.clear();
        const factory = this.resolver.resolveComponentFactory(NestedList);
        this.innerListComponentRef = this.containerForInnerList.createComponent(factory);

        const [getChildrenFunc, ...remainingGetChildrenFuncs] = this.getChildrenFuncs;
        const { headerTemplate, headerLevel, underlineHeader, children, childDisplayName, childDetailsState, childTemplate, getIsActive } = getChildrenFunc(this.item);

        const innerList = this.innerListComponentRef.instance;

        innerList.headerItem = this.item;
        innerList.headerDisplayName = this.displayName;
        innerList.headerDetailsState = this.detailsState;
        innerList.headerTemplate = headerTemplate || this.itemTemplate;
        innerList.headerLevel = headerLevel;
        innerList.underlineHeader = underlineHeader;

        innerList.items = children;
        innerList.getChildrenFuncs = remainingGetChildrenFuncs;
        innerList.itemDisplayName = childDisplayName;
        innerList.itemDetailsState = childDetailsState;
        innerList.itemTemplate = childTemplate;
        innerList.getIsActive = getIsActive;

        innerList.searchText = this.searchText;
        innerList.showInactive = this.showInactive;
        innerList.nestingLevel = this.nestingLevel + 1;
    }

    @ViewChild("itemContainer", { read: ViewContainerRef }) containerForItem: ViewContainerRef;
    @ViewChild("innerListContainer", { read: ViewContainerRef }) containerForInnerList: ViewContainerRef;
    @ViewChild('defaultItemTemplate') defaultTemplateForItem: TemplateRef<any>;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/nested-list-item.component.ts